import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';

import { ScrollTopComponent } from './footer/scroll-to-top/scroll-top.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [FooterComponent, ScrollTopComponent],
  imports: [RouterModule, CoreCommonModule],
  exports: [FooterComponent]
})
export class FootersModule { }
